import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Button from "./Button";
import Icon from "../AppIcon";

const Header = ({ title = "Sales Analytics Dashboard" }) => {
  const navigate = useNavigate();
  const { user, userProfile, signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate("/login");
    } catch (error) {
      console.log("Sign out error:", error);
    }
  };

  return (
    <header className="bg-background border-b border-border w-full fixed top-0 z-[100]">
      <div className="mx-auto px-4 lg:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Title */}
          <div className="flex items-center space-x-3">
            <div className="h-8 w-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon
                name="BarChart3"
                size={18}
                className="text-primary-foreground"
              />
            </div>
            <div>
              <h1 className="text-sm sm:text-lg font-semibold text-foreground">
                {title}
              </h1>
            </div>
          </div>

          {/* User Info and Actions */}
          <div className="flex items-center space-x-4">
            {/* User Profile Info */}
            <div className="hidden sm:flex items-center space-x-3">
              <div className="text-right">
                <p className="text-sm font-medium text-foreground">
                  {userProfile?.full_name ||
                    user?.email?.split("@")[0] ||
                    "User"}
                </p>
                <p className="text-xs text-muted-foreground capitalize">
                  {userProfile?.role || "user"} • {user?.email}
                </p>
              </div>
              <div className="h-8 w-8 bg-muted rounded-full flex items-center justify-center">
                <Icon
                  name={userProfile?.role === "admin" ? "Shield" : "User"}
                  size={16}
                  className="text-muted-foreground"
                />
              </div>
            </div>

            {/* Navigation Actions */}
            <div className="flex items-center space-x-2">
              {userProfile?.role === "admin" && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate("/")}
                  iconName="BarChart3"
                  iconPosition="left"
                  className="hidden sm:flex"
                >
                  Dashboard
                </Button>
              )}

              {/* {userProfile?.role === 'admin' && (
                <div className="relative group hidden sm:flex">
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="BarChart3"
                    iconPosition="left"
                    className="group-hover:bg-accent"
                  >
                    Dashboards
                  </Button>
                  <div className="absolute z-10 hidden group-hover:block bg-popover border border-border rounded-md mt-1 shadow-lg">
                    <button
                      onClick={() => navigate('/executive-sales-overview-dashboard')}
                      className="block w-full text-left px-4 py-2 hover:bg-muted text-sm"
                    >
                      Executive Overview
                    </button>
                    <button
                      onClick={() => navigate('/company-performance-analytics-dashboard')}
                      className="block w-full text-left px-4 py-2 hover:bg-muted text-sm"
                    >
                      Company Performance
                    </button>
                    <button
                      onClick={() => navigate('/real-time-operations-monitoring-dashboard')}
                      className="block w-full text-left px-4 py-2 hover:bg-muted text-sm"
                    >
                      Real-Time Monitoring
                    </button>
                  </div>
                </div>
              )} */}

              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate("/data-entry-and-validation-interface")}
                iconName="Edit"
                iconPosition="left"
                className="hidden sm:flex"
              >
                Data Entry
              </Button>

              <Button
                variant="outline"
                size="sm"
                onClick={handleSignOut}
                iconName="LogOut"
                iconPosition="left"
              >
                Sign Out
              </Button>
            </div>
          </div>
        </div>

        {/* Mobile User Info */}
        <div className="sm:hidden pb-3 border-t border-border mt-3 pt-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="h-8 w-8 bg-muted rounded-full flex items-center justify-center">
                <Icon
                  name={userProfile?.role === "admin" ? "Shield" : "User"}
                  size={16}
                  className="text-muted-foreground"
                />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">
                  {userProfile?.full_name ||
                    user?.email?.split("@")[0] ||
                    "User"}
                </p>
                <p className="text-xs text-muted-foreground capitalize">
                  {userProfile?.role || "user"}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              {userProfile?.role === "admin" && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate("/")}
                  iconName="BarChart3"
                  className="h-8 w-8 p-0"
                />
              )}

              <Button
                variant="ghost"
                size="sm"
                onClick={() => navigate("/data-entry-and-validation-interface")}
                iconName="Edit"
                className="h-8 w-8 p-0"
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
